import { render, staticRenderFns } from "./personCard.vue?vue&type=template&id=c3c85e3c"
import script from "./personCard.vue?vue&type=script&lang=js"
export * from "./personCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports